import {SportstypeSpec} from "../types";
import start from "../../icons/american_football/start";
import end from "../../icons/american_football/end";
import extraPoint from "../../icons/american_football/extra-point";
import fieldGoal from "../../icons/american_football/field-goal";
import fumble from "../../icons/american_football/fumble";
import interception from "../../icons/american_football/interception";
import punt from "../../icons/american_football/punt";
import safety from "../../icons/american_football/safety";
import touchdown from "../../icons/american_football/touchdown";
import turnoverOnDowns from "../../icons/american_football/turnover-on-downs";
import twoMinuteWarning from "../../icons/american_football/two-minute-warning";
import twoPointConversion from "../../icons/american_football/two-point-conversion";
import yellowFlag from "../../icons/american_football/yellow-flag";
import timeout from "../../icons/american_football/timeout";
import main from "../../icons/american_football/main";
import pauseQuarters from "../../icons/american_football/pause-quarters";
import resumeQuarters from "../../icons/american_football/resume-quarters";
import endOfRegularPlay from "../../icons/american_football/end-of-regular-play";
import startOvertime from "../../icons/american_football/start-overtime";
import pauseOvertime from "../../icons/american_football/pause-overtime";
import resumeOvertime from "../../icons/american_football/resume-overtime";
import endOfOvertime from "../../icons/american_football/end-of-overtime";
import redFlag from "../../icons/american_football/red-flag";
import { initializeTeamGameScoreboard, scoreChange } from "../eventHandlerUtils";
import injuryTimeout from "../../icons/american_football/injury-timeout";
import touchback from "../../icons/american_football/touchback";

const american_football: SportstypeSpec = {
  id: 'american_football',
  scoreboardType: 'team-game-scoreboard',
  svg: main,
  releaseStage: 'released',
  defaultTiming: {
    _type: "Tik::Model::Options::TimedGameOptions",
    num_regular_phases: 4,
    num_overtime_phases: 2,
    regular_phase_length: 15,
    timing_type: "d",
    overtime_phase_length: 15
  },
  displayTimeFormat: "M:ss",
  displayPhaseFormat: 'long',
  displayPhaseOvertimeFormat: 'overtime',
  events: [
    {
      id: 'start',
      important: false,
      svg: start,
      eventHandler: initializeTeamGameScoreboard
    },
    {
      id: 'pause-quarters',
      important: false,
      svg: pauseQuarters
    },
    {
      id: 'resume-quarters',
      important: false,
      svg: resumeQuarters
    },
    {
      id: 'end-of-regular-play',
      important: false,
      svg: endOfRegularPlay
    },
    {
      id: 'start-overtime',
      important: false,
      svg: startOvertime
    },
    {
      id: 'pause-overtime',
      important: false,
      svg: pauseOvertime
    },
    {
      id: 'resume-overtime',
      important: false,
      svg: resumeOvertime
    },
    {
      id: 'end-of-overtime',
      important: false,
      svg: endOfOvertime
    },
    {
      id: 'end',
      important: false,
      svg: end
    },
    {
      id: 'touchdown',
      important: true,
      svg: touchdown,
      team: 'any',
      players: [
        {
          id: 'scorer'
        }
      ],
      eventHandler: scoreChange(6)
    },
    {
      id: 'field-goal',
      important: true,
      svg: fieldGoal,
      team: 'any',
      players: [
        {
          id: 'scorer'
        }
      ],
      eventHandler: scoreChange(3)
    },
    {
      id: 'extra-point',
      important: true,
      svg: extraPoint,
      team: 'any',
      players: [
        {
          id: 'scorer'
        }
      ],
      eventHandler: scoreChange(1)
    },
    {
      id: 'two-point-conversion',
      important: true,
      svg: twoPointConversion,
      team: 'any',
      players: [
        {
          id: 'scorer'
        }
      ],
      eventHandler: scoreChange(2)
    },
    {
      id: 'yellow-flag',
      important: true,
      svg: yellowFlag,
      team: 'any',
      players: [
        {
          id: 'offender'
        }
      ]
    },
    {
      id: 'red-flag',
      important: false,
      svg: redFlag,
      team: 'any'
    },
    {
      id: 'timeout',
      important: true,
      svg: timeout,
      team: "any"
    },
    {
      id: 'two-minute-warning',
      important: true,
      svg: twoMinuteWarning
    },
    {
      id: 'punt',
      important: true,
      svg: punt,
      team: "any"
    },
    {
      id: 'fumble',
      important: true,
      svg: fumble,
      team: "any",
      players: [
        {
          id: "offender"
        }
      ]
    },
    {
      id: 'interception',
      important: true,
      svg: interception,
      team: 'any',
      players: [
        {
          id: 'offender'
        }
      ]
    },
    {
      id: 'turnover-on-downs',
      important: true,
      svg: turnoverOnDowns,
      team: "any"
    },
    {
      id: 'safety',
      important: true,
      svg: safety,
      team: 'any',
      players: [
        {
          id: 'scorer'
        }
      ],
      eventHandler: scoreChange(2)
    },
    {
      id: 'touchback',
      important: true,
      svg: touchback,
      team: "any"
    },
    {
      id: 'injury-timeout',
      important: true,
      svg: injuryTimeout,
      team: "any",
      players: [
        {
          id: 'injured'
        }
      ]
    }
  ],
  legacyEventMap: {
    30: 'timeout',
    31: 'two-minute-warning',
    91: 'punt',
    92: 'fumble',
    93: 'interception',
    94: 'turnover-on-downs',
    102: 'safety',
    103: 'field-goal',
    106: 'touchdown',
    121: 'extra-point',
    122: 'two-point-conversion',
    250: 'yellow-flag'
  }
}

export default american_football
